import { ToastOptions } from 'react-toastify';
export const toastOptions: ToastOptions = {
  position: 'bottom-left',
  autoClose: false,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'colored',
  type: 'info',
};
